// extracted by mini-css-extract-plugin
module.exports = {"pagination-wrapper":"pagination-wrapper___3CW0U","pagination":"pagination___1G8Q7"};